import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

interface PublicRouteProps {
  children: React.ReactNode;
  /** Where to redirect if user is already authenticated. Defaults to '/dashboard' */
  redirectTo?: string;
}

/**
 * Route wrapper that redirects authenticated users away from public pages like login/signup.
 * Renders children immediately (optimistic) to avoid blocking FCP on the Cognito auth check.
 * If the auth check resolves as authenticated, we redirect at that point.
 */
export function PublicRoute({ children, redirectTo = "/dashboard" }: PublicRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();

  if (!isLoading && isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
